import type { Fallacy } from "./types";
import { createStory } from "./types";

export const texasSharpshooter: Fallacy = {
    id: "texas-sharpshooter",
    name: "Texas Sharpshooter",
    emoji: "🤠",
    category: "Manipulasi Statistik",
    description: "**Menggambar target setelah menembak** — memilih pola dari **data acak** lalu mengklaimnya bermakna.",
    tldr: "Tembak dulu sembarangan, baru gambar lingkaran targetnya di lubang peluru.",
    detail: "Texas Sharpshooter Fallacy dinamai dari lelucon tentang penembak yang menembaki dinding secara acak, lalu menggambar target di sekitar kumpulan lubang peluru terapat, dan mengklaim dirinya penembak jitu. Dalam konteks data, ini berarti **menemukan pola dalam data acak** dan mengklaimnya bermakna.\n\nKekeliruan ini umum dalam dataset besar. Jika menganalisis cukup banyak variabel, pasti ada yang tampak berkorelasi — murni kebetulan. Misalnya, penjualan es krim berkorelasi dengan kriminalitas, padahal keduanya hanya naik bersamaan saat musim panas.\n\nCara menghindarinya: **hipotesis harus dibuat sebelum melihat data**, bukan sesudahnya. Pola menarik dalam data perlu divalidasi dengan dataset baru yang independen sebelum dianggap bermakna.",
    story: createStory("Texas Sharpshooter", "🤠", {
      hook: {
        title: "Tembak dulu sembarangan.",
        body: "Baru gambar lingkaran targetnya di lubang peluru. \"Wah aku jitu banget!\" Pernah liat orang kayak gini?",
      },
      convo: {
        claim: "Aku analisis data penjualan 2 tahun, ternyata **penjualan naik tiap tanggal dobel** — 2/2, 4/4, 8/8. Berarti ada efek numerologi ke perilaku konsumen!",
        response: "Kalau cari-cari cukup lama, pola apa pun bisa \"ditemukan\". **Targetnya digambar setelah nembak.**",
      },
      reveal: {
        body: "**Nemuin pola di data acak**, lalu ngeklaim itu bermakna. Targetnya digambar **setelah** nembak.",
      },
      insight: {
        title: "Aturan mainnya:",
        body: "Kesimpulan harus dibuat **SEBELUM lihat data**, bukan sesudahnya. Kalau kamu cari-cari pola setelah lihat data, pasti ketemu — tapi belum tentu bermakna.",
      },
      engagement: {
        title: "Pernah nemu \"pola\" yang ternyata cuma kebetulan?",
        body: "Di data kerjaan atau kehidupan sehari-hari? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["cherry-picking", "post-hoc", "gamblers-fallacy", "misleading-statistics"],
  };
